angular.module('7Shop.Core').constant('SevenRoutes', {});
